export default {
  path: '/profile_parameters',
  name: 'profile_parameters',
  component: () => import('../components/profileparameter/Layout'),
  redirect: { name: 'ProfileParameterList' },
  meta: {
    breadcrumb: 'profile.profileparameter.parameters',
  },
  children: [
    {
      name: 'ProfileParameterList',
      path: '',
      component: () => import('../views/profileparameter/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ProfileParameterCreate',
      path: 'new',
      component: () => import('../views/profileparameter/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ProfileParameterUpdate',
      path: ':id/edit',
      component: () => import('../views/profileparameter/Update'),
      meta: {
        breadcrumb: 'profile.profileparameter.parameter',
      },
    },
    {
      name: 'ProfileParameterShow',
      path: ':id',
      component: () => import('../views/profileparameter/Show'),
      meta: {
        breadcrumb: 'profile.profileparameter.parameter',
      },
    }
  ]
};
